import React from "react";
import { auth, googleProvider, ALLOWED_EMAIL } from "./firebase";
import { signInWithPopup, signOut } from "firebase/auth";
import { Button, Container, Card } from "react-bootstrap";

const Login = ({ setUser }) => {
  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);

      if (result.user.email !== ALLOWED_EMAIL) {
        await signOut(auth);
        alert("Acces neautorizat. Contactează administratorul aplicației.");
        return;
      }

      setUser(result.user);
    } catch (error) {
      console.error("Eroare login:", error);
    }
  };

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <Card className="p-5 text-center" style={{ width: "400px" }}>
        <h2 className="mb-4">Fenestra ERP</h2>
        <p className="text-muted mb-4">Conectează-te pentru a continua</p>
        <Button variant="danger" onClick={handleLogin}>
          Conectare cu Google
        </Button>
      </Card>
    </Container>
  );
};

export default Login;
